import { useGetOGPUserInfo } from 'ogp/hooks';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';
import { CompanyRole } from '@types';

export const useIsHqAdmin = () => {
  const userQuery = useGetOGPUserInfo();
  const isHqAdmin =
    userQuery.data &&
    hasAccessWithinPolicyGroup(PolicyGroups.COMPANY, userQuery.data.userInfo, CompanyRole.HQADMIN);
  return isHqAdmin ?? false;
};
